(() => {
  try {
    const hasSpeedtestBeenRun =
      true || // This disables the speedtest
      !!window.sessionStorage.getItem('swinger.speedtest') ||
      !!window.Cookies.get('swinger.speedtest') ||
      window.name === 'swinger.speedtest';

    if (!hasSpeedtestBeenRun) {
      window[window.requestIdleCallback ? 'requestIdleCallback' : 'setTimeout'](() => {
        if (
          navigator.connection &&
          navigator.connection.saveData
        ) {
          return;
        }

        const speedtestWorker = new Worker(`/js/workers/speedtest-worker.es5.js?v=${(new Date()).getTime()}`);

        speedtestWorker.addEventListener('message', (e) => {
          const serverspeeds = JSON.parse(window.localStorage.getItem('swinger.serverspeeds') || window.localStorage.getItem(atob('a25wYi5zZXJ2ZXJzcGVlZHM=')) || '{}');
          const logfileUrl = `https://${e.data.server}.dvdl.net/rand100.txt`;
          const averageMbitPerSecond = e.data.speed;

          serverspeeds[e.data.server] = e.data.speed;

          try {
            window.localStorage.setItem('swinger.serverspeeds', JSON.stringify(serverspeeds));
          } catch (e) {
            // noop
          }

          if (
            navigator.userAgent.toLowerCase().indexOf('bot') > -1
          ) {
            return;
          }

          if (
            !navigator.connection ||
            !navigator.connection.effectiveType
          ) {
            return;
          }

          if (
            navigator.connection &&
            navigator.connection.effectiveType &&
            ['slow-2g', '2g', '3g'].indexOf(navigator.connection.effectiveType) > -1
          ) {
            return;
          }

          const xhrUrl = `${logfileUrl}?mbit=${averageMbitPerSecond}`;
          const xhr = new XMLHttpRequest();
          xhr.open('GET', xhrUrl);
          xhr.send();

          window._paq = window._paq || [];
          window._paq.push([
            'trackEvent',
            'Metrics',
            'Download Speed',
            e.data.server,
            e.data.speed
          ]);
        });

        try {
          window.sessionStorage.setItem('swinger.speedtest', 'true');
        } catch (e) {
          // noop
        }
        window.name = 'swinger.speedtest';
        document.cookie = 'swinger.speedtest=true;path=/;max-age=86400';
      }, {
        timeout: 5000
      });
    }
  } catch (e) {
    // noop
  }
})();
